"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = void 0;
const validation_1 = __importDefault(require("../../../../validation"));
const rules_1 = __importDefault(require("../../../../validation/rules"));
const patchBodyRules = {
    firstName: rules_1.default.string().label('First Name').required(),
    lastName: rules_1.default.string().label('Last Name').required(),
    organizationRoles: rules_1.default.array().of(rules_1.default.string().required()).min(1, 'Roles are required').label('Roles')
        .required(),
    jobTitle: rules_1.default.string().label('Job Title').optional(),
};
const patchBody = {
    rules: patchBodyRules,
    schema: validation_1.default.schema(patchBodyRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.patch = { body: patchBody };
